import { getIfInboxHasAi, handoverInboxAiSession } from 'widget/api/chatbot';
import { changeAiNest } from '../../../api/chatbot';

export const actions = {
  checkIfInboxHasAi: async ({ commit, getters }, { sourceId }) => {
    try {
      if (getters?.getUiFlags?.isAlreadyFetched) {
        return;
      }

      commit('setChatbotUiFlags', { isLoading: true });
      commit('clearAiNests');

      // Make a delay for proper AI fetching
      // TODO: Remove when it will be fixed on backend side
      await new Promise((resolve) => {
        setTimeout(resolve, 500);
      });

      const { data } = await getIfInboxHasAi(sourceId);

      const isHandover = JSON.parse(
        localStorage.getItem(`isAiChatHandover:${sourceId}`)
      );

      commit('setIsInboxHasAi', data.hasChatlynAI);
      commit('setAiNests', data.nests || []);
      commit(
        'setIsChatAiHandover',
        typeof isHandover === 'boolean' ? isHandover : !data.hasChatlynAI
      );
      commit('setInboxAiName', data.name);
      commit('setChatbotUiFlags', { isAlreadyFetched: true });
    } catch (error) {
      // Ignore error
    } finally {
      commit('setChatbotUiFlags', { isLoading: false });
    }
  },

  handoverAiChat: async ({ commit }, { sourceId }) => {
    try {
      commit('setChatbotUiFlags', { isLoading: true });

      const { data } = await handoverInboxAiSession(sourceId);

      localStorage.setItem(
        `isAiChatHandover${sourceId}`,
        JSON.stringify(data.handover)
      );
      commit('setIsChatAiHandover', data.handover);
    } catch (error) {
      // Ignore error
    } finally {
      commit('setChatbotUiFlags', { isLoading: false });
    }
  },

  changeAiNest: async ({ commit }, { sourceId, nestId }) => {
    try {
      commit('setChatbotUiFlags', { isLoading: true });

      await changeAiNest(sourceId, nestId);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setChatbotUiFlags', { isLoading: false });
    }
  },
};
